import { API_URL } from 'shared/api/Constants';
import { apiInterceptor } from './axios';

export const getAppointmentHistoryAPI = (patientId: any) => {
  return apiInterceptor.get(`${API_URL.APPOINTMENT_HISROTY}/${patientId}`).then((response: any) => {
    return response;
  });
};